import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import swal from "sweetalert";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { API_URL } from "../../config";
import InvoiceBody from "./quotation_invoice_body";
import { currentDateTime, dateTimeFormat } from "../../lib/functions";
import PrintIcon from "@material-ui/icons/Print";
import GetAppIcon from "@material-ui/icons/GetApp";
import EmailIcon from "@material-ui/icons/Email";
import { AttachFile, Cancel } from "@material-ui/icons";
import moment from "moment";
import ReactToPrint from "react-to-print";
import "./css/invoice.css";
import commaNumber from "comma-number";
import {
  Modal,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@material-ui/core";

let format = commaNumber.bindWith(",", ".");

// Off-screen export container is rendered (not hidden) so html2canvas can capture it
const useStyles = makeStyles((theme) => ({
  modal: { display: "flex", alignItems: "center", justifyContent: "center" },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    minWidth: 500,
    maxWidth: 600,
  },
  selectedEmailsList: {
    maxHeight: 200,
    overflow: "auto",
    marginTop: theme.spacing(2),
    border: "1px solid #eee",
    borderRadius: 4,
  },
  printForExport: {
    position: "absolute",
    left: "-10000px",
    top: 0,
    width: "794px", 
    background: "#fff",
    pointerEvents: "none",
    zIndex: -1,
  },
  plusLinkDiv: {
    marginBottom: theme.spacing(2),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
}));

const EmailModal = ({ open, handleClose, ccEmail, setCcEmail, authInfo }) => {
  const classes = useStyles();
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) fetchCCEmails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const fetchCCEmails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/get-email-cc-names`,
        {},
        {
          headers: {
            "auth-token": authInfo.token,
            "Content-Type": "application/json",
          },
        }
      );
      setEmailOptions(response.data.message);
    } catch (error) {
      console.error("Error fetching CC emails:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddEmail = () => {
    if (
      selectedEmail &&
      !ccEmail.some((email) => email.email_cc_email === selectedEmail.email_cc_email)
    ) {
      setCcEmail([...ccEmail, selectedEmail]);
      setSelectedEmail(null);
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    setCcEmail(ccEmail.filter((email) => email.email_cc_email !== emailToRemove.email_cc_email));
  };

  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <div className={classes.paper}>
        <Typography variant="h6" gutterBottom>
          Add CC Emails
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={8} className={classes.plusLinkDiv}>
            <Autocomplete
              style={{ width: "100%" }}
              options={emailOptions}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option?.email_cc_email || ""}
              value={selectedEmail}
              onChange={(event, selectedObj) => {
                setSelectedEmail(selectedObj);
              }}
              loading={loading}
              renderInput={(params) => (
                <TextField {...params} label="Choose a CC Email" variant="outlined" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleAddEmail}
              disabled={!selectedEmail}
              className={classes.actionButton}
            >
              Add Email
            </Button>
          </Grid>
        </Grid>

        {ccEmail.length > 0 && (
          <div className={classes.selectedEmailsList}>
            <List dense>
              {ccEmail.map((email) => (
                <ListItem key={email.email_cc_email}>
                  <ListItemText
                    primary={email.email_cc_name || email.email_cc_email}
                    secondary={email.email_cc_email ? email.email_cc_email : ""}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={() => handleRemoveEmail(email)} size="small">
                      <Cancel fontSize="small" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </div>
        )}

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button onClick={handleClose} color="primary" variant="contained">
            Done
          </Button>
        </Box>
      </div>
    </Modal>
  );
};

class PrintAbleSection extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    sale: {},
    email: "",
    institutionProfile: "",
    customerDue: 0,
    modalOpen: false,
    ccEmail: [],
  };

  componentDidMount() {
    if (this.props.saleId) {
      this.getsale();
    }
    this.getProfile();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.saleId !== this.props.saleId ||
      prevProps.selectedInvoiceNo !== this.props.selectedInvoiceNo
    ) {
      this.getsale();
      this.getProfile();
    }
  }

  handleOpenModal = () => this.setState({ modalOpen: true });
  handleCloseModal = () => this.setState({ modalOpen: false });

  getProfile = async () => {
    await axios
      .get(`${API_URL}/api/get-institution`, { headers: { "auth-token": this.props.authInfo.token } })
      .then((res) => {
        this.setState({ institutionProfile: res.data });
      });
  };

  normalizeSaleData = (payload) => {
    const raw =
      payload?.message?.[0] ||
      payload?.message ||
      payload?.data?.[0] ||
      payload?.data ||
      null;

    if (!raw || typeof raw !== "object") return null;

    const details = Array.isArray(raw.details)
      ? raw.details
      : Array.isArray(raw.line_items)
        ? raw.line_items
        : Array.isArray(raw.items)
          ? raw.items
          : [];

    return {
      ...raw,
      details,
      customer_code: raw.customer_code || raw.customer_id || raw.sale_customer_id || "",
      customer_name: raw.customer_name || raw.sale_customer_name || raw.customer_full_name || "",
      customer_institution_name:
        raw.customer_institution_name || raw.customer_company_name || raw.institution_name || "",
      customer_address: raw.customer_address || raw.sale_customer_address || "",
      customer_mobile_no: raw.customer_mobile_no || raw.sale_customer_mobile_no || "",
      employee_name:
        raw.employee_name || raw.sales_person_name || raw.sale_created_by_name || raw.user_full_name || "",
      sale_invoice: raw.sale_invoice || raw.quotation_invoice || raw.invoice_no || "",
      sale_created_isodt: raw.sale_created_isodt || raw.created_isodt || raw.sale_date_time || "",
      customer_id: raw.customer_id || raw.sale_customer_id || 0,
    };
  };

  extractSummaryDetails = (payload) => {
    if (Array.isArray(payload?.details)) return payload.details;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.message)) return payload.message;
    return [];
  };

  hasEnoughInvoiceData = (row) => {
    if (!row || typeof row !== "object") return false;
    const detailsCount = Array.isArray(row.details) ? row.details.length : 0;
    return Boolean(
      row.customer_name ||
        row.customer_id ||
        row.sale_customer_id ||
        row.sale_invoice ||
        detailsCount > 0
    );
  };

  fetchByQuotationDetails = async (headers, candidateSaleId) => {
    const urls = [
      `${API_URL}/api/get-quotation-with-details`,
      `${API_URL}/get-quotation-with-details`,
    ];

    let lastErr = null;
    for (const url of urls) {
      try {
        const res = await axios.post(
          url,
          { reqPayload: { saleId: Number(candidateSaleId), from: "invoice" } },
          { headers }
        );
        const normalized = this.normalizeSaleData(res?.data);
        if (this.hasEnoughInvoiceData(normalized)) return normalized;
      } catch (err) {
        lastErr = err;
      }
    }
    if (lastErr) {
      console.warn("fetchByQuotationDetails failed:", lastErr?.response?.data || lastErr?.message);
    }
    return null;
  };

  fetchBySummary = async (headers, invoiceNo, candidateSaleIds = []) => {
    const urls = [
      `${API_URL}/api/get-sales-quotation-summary`,
      `${API_URL}/get-sales-quotation-summary`,
      `${API_URL}/api/api/get-sales-quotation-summary`,
    ];
    const invoiceNoStr = String(invoiceNo || "").trim();

    for (const saleId of candidateSaleIds) {
      for (const url of urls) {
        try {
          const res = await axios.get(url, { headers, params: { sale_id: Number(saleId), status: "a" } });
          const details = this.extractSummaryDetails(res?.data);
          if (!details.length) continue;
          const picked = details[0];
          const normalized = this.normalizeSaleData({ message: [picked] });
          if (this.hasEnoughInvoiceData(normalized)) return normalized;
        } catch (_e1) {
          try {
            const res = await axios.post(url, { sale_id: Number(saleId), status: "a" }, { headers });
            const details = this.extractSummaryDetails(res?.data);
            if (!details.length) continue;
            const picked = details[0];
            const normalized = this.normalizeSaleData({ message: [picked] });
            if (this.hasEnoughInvoiceData(normalized)) return normalized;
          } catch (_e2) {
            // try next url
          }
        }
      }
    }

    if (!invoiceNoStr) return null;

    for (const url of urls) {
      try {
        const res = await axios.get(url, { headers, params: { status: "a" } });
        const details = this.extractSummaryDetails(res?.data);
        const picked = details.find((d) => String(d?.sale_invoice || d?.sale_invoice_no || "").trim() === invoiceNoStr);
        if (!picked) continue;
        const normalized = this.normalizeSaleData({ message: [picked] });
        if (this.hasEnoughInvoiceData(normalized)) return normalized;
      } catch (_e1) {
        try {
          const res = await axios.post(url, { status: "a" }, { headers });
          const details = this.extractSummaryDetails(res?.data);
          const picked = details.find((d) => String(d?.sale_invoice || d?.sale_invoice_no || "").trim() === invoiceNoStr);
          if (!picked) continue;
          const normalized = this.normalizeSaleData({ message: [picked] });
          if (this.hasEnoughInvoiceData(normalized)) return normalized;
        } catch (_e2) {
          // try next url
        }
      }
    }

    return null;
  };

  getsale = async () => {
    if (!this.props.saleId && !this.props.selectedInvoiceNo) return;

    try {
      const headers = { "auth-token": this.props.authInfo.token };
      const selectedInvoiceNo = String(this.props.selectedInvoiceNo || "").trim();
      const invoiceTailId = selectedInvoiceNo ? Number((selectedInvoiceNo.split("-").pop() || "").trim()) : NaN;
      const candidateSaleIds = Array.from(
        new Set(
          [this.props.saleId, this.props?.selectedInvoice?.sale_id, invoiceTailId]
            .map((v) => Number(v))
            .filter((v) => Number.isFinite(v) && v > 0)
        )
      );

      let saleRow = null;
      for (const candidate of candidateSaleIds) {
        // eslint-disable-next-line no-await-in-loop
        saleRow = await this.fetchByQuotationDetails(headers, candidate);
        if (saleRow) break;
      }

      if (!saleRow) {
        saleRow = await this.fetchBySummary(headers, selectedInvoiceNo, candidateSaleIds);
      }

      this.setState({ sale: saleRow || {} });

      const customerId = saleRow?.customer_id;
      if (!customerId) {
        this.setState({ email: "" });
        return;
      }

      const emailRes = await axios.post(
        `${API_URL}/api/get-email-address`,
        {
          reqPayload: { saleId: Number(this.props.saleId), from: "invoice" },
          customerId,
        },
        { headers }
      );
      this.setState({ email: emailRes?.data?.email || "" });
    } catch (err) {
      console.error("Quotation invoice load failed:", err?.response?.data || err.message);
      this.setState({ sale: {}, email: "" });
    }
  };

  sendMail = async () => {
    const { email, institutionProfile, ccEmail } = this.state;

    if (!email || email.trim() === "") {
      swal({ title: "Customer email is empty", icon: "warning" });
      return false;
    }

    const ccEmails = ccEmail.map((emailObj) => emailObj.email_cc_email);

    const prompt = {
      title: ccEmail.length < 1 ? "Do you want to send email without CC?" : "Do you want to send email with CC?",
      text: `To: ${email}${ccEmail.length > 0 ? `\nCC: ${ccEmails.join(", ")}` : ""}`,
      icon: "info",
      buttons: true,
    };

    const confirmResult = await swal(prompt);
    if (!confirmResult) return;

    try {
      const res = await axios.post(
        `${API_URL}/api/send-quotation-invoice`,
        {
          reqPayload: { saleId: this.props.saleId, from: "invoice" },
          sale: this.state.sale,
          email,
          ccEmail: ccEmails,
          institutionProfile,
          showDetailedView: this.props.showDetailedView,
          footerImage: this.props.footerImage,
        },
        {
          headers: {
            "auth-token": this.props.authInfo.token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.data.error) {
        swal({ title: "Email sent successfully!", icon: "success" });
      } else {
        throw new Error(res.data.message || "Failed to send email");
      }
    } catch (error) {
      console.error("Error sending mail:", error);
      swal({ title: "Failed to send email", text: error.message, icon: "error" });
    }
  };

  convertNumberToWords = (amountToWord) => {
    var words = [];
    words[0] = "";
    words[1] = "One";
    words[2] = "Two";
    words[3] = "Three";
    words[4] = "Four";
    words[5] = "Five";
    words[6] = "Six";
    words[7] = "Seven";
    words[8] = "Eight";
    words[9] = "Nine";
    words[10] = "Ten";
    words[11] = "Eleven";
    words[12] = "Twelve";
    words[13] = "Thirteen";
    words[14] = "Fourteen";
    words[15] = "Fifteen";
    words[16] = "Sixteen";
    words[17] = "Seventeen";
    words[18] = "Eighteen";
    words[19] = "Nineteen";
    words[20] = "Twenty";
    words[30] = "Thirty";
    words[40] = "Forty";
    words[50] = "Fifty";
    words[60] = "Sixty";
    words[70] = "Seventy";
    words[80] = "Eighty";
    words[90] = "Ninety";
    let amount = amountToWord == null ? "0.00" : amountToWord.toString();
    var atemp = amount.split(".");
    var number = atemp[0].split(",").join("");
    var n_length = number.length;
    var words_string = "";
    if (n_length <= 9) {
      var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var received_n_array = new Array();
      for (var i = 0; i < n_length; i++) {
        received_n_array[i] = number.substr(i, 1);
      }
      for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
        n_array[i] = received_n_array[j];
      }
      for (var i = 0, j = 1; i < 9; i++, j++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          if (n_array[i] == 1) {
            n_array[j] = 10 + parseInt(n_array[j]);
            n_array[i] = 0;
          }
        }
      }
      let value = "";
      for (var i = 0; i < 9; i++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          value = n_array[i] * 10;
        } else {
          value = n_array[i];
        }
        if (value !== 0) {
          words_string += words[value] + " ";
        }
        if ((i == 1 && value !== 0) || (i == 0 && value !== 0 && n_array[i + 1] == 0)) {
          words_string += "Crores ";
        }
        if ((i == 3 && value !== 0) || (i == 2 && value !== 0 && n_array[i + 1] == 0)) {
          words_string += "Lakhs ";
        }
        if ((i == 5 && value !== 0) || (i == 4 && value !== 0 && n_array[i + 1] == 0)) {
          words_string += "Thousand ";
        }
        if (i == 6 && value !== 0 && n_array[i + 1] !== 0 && n_array[i + 2] !== 0) {
          words_string += "Hundred and ";
        } else if (i == 6 && value !== 0) {
          words_string += "Hundred ";
        }
      }
      words_string = words_string.split("  ").join(" ");
    }
    return words_string + " only";
  };

  render() {
    let { sale, modalOpen, ccEmail } = this.state;
    let showDetailedView = this.props.showDetailedView;
    let footerImage = this.props.footerImage;

    const checkboxOptions = sale?.checkbox_options ? JSON.parse(sale.checkbox_options) : [];

    return (
      <div style={{ padding: "10px" }}>
        {!this.props.print && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
              <Button size="small" variant="outlined" startIcon={<EmailIcon />} onClick={this.sendMail}>
                Send Email
              </Button>
              <Button size="small" variant="outlined" startIcon={<AttachFile />} onClick={this.handleOpenModal}>
                Add CC
              </Button>
            </div>

            <EmailModal
              open={modalOpen}
              handleClose={this.handleCloseModal}
              ccEmail={ccEmail}
              setCcEmail={(emails) => this.setState({ ccEmail: emails })}
              authInfo={this.props.authInfo}
            />
          </>
        )}

        {sale != null ? (
          <>


            {!this.props.print && (
              <>
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <h3 className={"invoice-title"}>Quotation Invoice</h3>
                  </Grid>
                </Grid>
                <FormControl component="fieldset" style={{ marginBottom: "10px", marginLeft: "10px" }}>
                  <RadioGroup
                    row
                    aria-label="view-options"
                    name="view-options"
                    value={showDetailedView ? "B" : "A"}
                    onChange={(e) => this.props.setShowDetailedView(e.target.value === "B")}
                  >
                    <FormControlLabel value="A" control={<Radio />} label="Option A" />
                    <FormControlLabel value="B" control={<Radio />} label="Option B" />
                  </RadioGroup>
                  <RadioGroup
                    row
                    aria-label="footer-image"
                    name="footer-image"
                    value={footerImage}
                    onChange={(e) => this.props.setFooterImage(e.target.value)}
                  >
                    <FormControlLabel value="none" control={<Radio />} label="None" />
                    <FormControlLabel value="skf" control={<Radio />} label="SKF" />
                    <FormControlLabel value="ntn" control={<Radio />} label="NTN" />
                  </RadioGroup>
                </FormControl>
              </>
            )}

            <Grid container style={{ marginBottom: "12px", fontSize: "13px" }}>
              <Grid item xs={6} sm={8}>
                <strong>Customer ID : </strong> <span>{sale.customer_code || sale.customer_id || "-"}</span>
                <br />
                <strong>Customer Name : </strong> <span>{sale.customer_name || "-"}</span>
                <br />
                <strong>Institution Name : </strong> <span>{sale.customer_institution_name || "-"}</span>
                <br />
                <strong>Customer Address : </strong> <span>{sale.customer_address || "-"}</span>
                <br />
                <strong>Customer Mobile : </strong> <span>{sale.customer_mobile_no || "-"}</span>
                <br />
              </Grid>
              <Grid item xs={6} sm={4} style={{ textAlign: "left" }}>
                <strong>Quotation By : </strong> <span>{sale.employee_name || "-"}</span>
                <br />
                <strong>Invoice No : </strong> <span>{sale.sale_invoice || this.props.selectedInvoiceNo || "-"}</span>
                <br />
                <strong> Date & Time : </strong>{" "}
                <span>{sale.sale_created_isodt ? moment(sale.sale_created_isodt).format(dateTimeFormat) : "-"}</span>
                <br />
              </Grid>
            </Grid>

            <InvoiceBody saleData={sale} showDetailedView={showDetailedView} />

            <Grid container>
              <Grid xs={6} sm={6} style={{ marginTop: "25px" }} />
              {showDetailedView && (
                <Grid xs={6} sm={6} style={{ marginTop: "2px" }}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td>Sub Total : </td>
                        <td style={{ textAlign: "right" }}>
                          {format(parseFloat(sale.sale_subtotal_amount).toFixed(2))}
                        </td>
                      </tr>
                      <tr>
                        <td>Transport Cost : </td>
                        <td style={{ textAlign: "right" }}>
                          {format(parseFloat(sale.sale_transport_cost).toFixed(2))}
                        </td>
                      </tr>
                      <tr>
                        <td>Vat :</td>
                        <td style={{ textAlign: "right" }}>
                          {format(parseFloat(sale.sale_vat_amount).toFixed(2))}
                        </td>
                      </tr>
                      <tr>
                        <td>Discount :</td>
                        <td style={{ textAlign: "right" }}>
                          {format(parseFloat(sale.sale_discount_amount).toFixed(2))}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ background: "#ccc" }}></td>
                        <td style={{ background: "#ccc" }}></td>
                      </tr>
                      <tr>
                        <td>Total : </td>
                        <td style={{ textAlign: "right" }}>
                          {format(parseFloat(sale.sale_total_amount).toFixed(2))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>
              )}

              <Grid xs={12} sm={12}>
                <p>In Word : {this.convertNumberToWords(sale.sale_total_amount)} </p>
                <p>Note : {sale.sale_note || "N/A"}</p>

                {checkboxOptions.length > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <strong>Terms & Conditions:</strong>
                    <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                      {checkboxOptions.map((option, index) => (
                        <li key={index}>{option}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </Grid>

              {!this.props.print && (
                <Grid item xs={12} style={{ textAlign: "right", marginTop: "20px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (this.props.history) {
                        this.props.history.push("/sales/sales-entry", {
                          quotationData: sale,
                          fromQuotation: true,
                        });
                      } else {
                        console.error("History prop missing");
                      }
                    }}
                  >
                    Return to Sales Entry
                  </Button>
                </Grid>
              )}
            </Grid>
          </>
        ) : null}
      </div>
    );
  }
}

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  state = { authInfo: this.props.authInfo, saleId: this.props.saleId };

  render() {
    const institution = this.props.institution;
    const selectedBrand = this.props.footerImage || "none";
    const hasBranding = selectedBrand !== "none";

    const type = institution?.pro_print_type; // "a4" | "1/2a4" | "pos"
    const hasFixedFooterPage = type === "a4" || type === "1/2a4";
    const FOOTER_HEIGHT_PX = hasBranding ? 130 : 0;
    const PAGE_HEIGHTS = {
      a4: "297mm",
      "1/2a4": "148.5mm",
      pos: null,
    };
    const pageHeight = PAGE_HEIGHTS[type] || null;

    const pageStyle = pageHeight
      ? {
        position: "relative",
        height: pageHeight,
        boxSizing: "border-box",
        overflow: "hidden",
      }
      : { position: "relative" };
    const contentWrapStyle = hasFixedFooterPage
      ? { paddingBottom: hasBranding ? `${FOOTER_HEIGHT_PX}px` : "0px" }
      : undefined;
    const footerWrapStyle = hasFixedFooterPage
      ? { position: "absolute", left: 0, right: 0, bottom: "5px", padding: "0 5mm 0" }
      : { marginTop: "20px", padding: "0 5mm 0" };

    const brandLogoMap = {
      skf: "/images/quotation/skf-logo.svg",
      ntn: "/images/quotation/ntn-middle-east.svg",
    };

    const renderBrandHeader = () => {
      if (!hasBranding) return null;

      return (
        <div style={{ marginBottom: "8px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              borderBottom: "3px solid #2d4c81",
              paddingBottom: "4px",
            }}
          >
            <img
              src="/images/quotation/sbm-header-logo.svg"
              alt="SBM"
              style={{ width: "102px", height: "102px", objectFit: "contain", flexShrink: 0 }}
            />
            <div style={{ flex: 1, textAlign: "center", lineHeight: 1.15, paddingTop: "2px" }}>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#2f3f66",
                  fontFamily: '"Noto Sans Bengali", "SolaimanLipi", Arial, sans-serif',
                }}
              >
                শরিফ বিয়ারিং এন্ড মেশিনারিজ
              </div>
              <div style={{ fontSize: "32px", fontWeight: 700, color: "#57a85a", letterSpacing: "0.5px" }}>
                SHARIF BEARING &amp; MACHINERIES
              </div>
              <div style={{ fontSize: "12px", color: "#111", marginTop: "4px" }}>
                Importer, Wholesaler &amp; Retailer of all kinds of Ball, Taper and Roller Bearings
              </div>
              <div style={{ fontSize: "12px", color: "#111", marginTop: "1px" }}>
                <strong>Address:</strong> <em>89 Nawabpur Road, Nawabpur, Dhaka-1100, Bangladesh</em>
              </div>
              <div style={{ fontSize: "12px", color: "#111", marginTop: "1px" }}>
                <strong>Telephone:</strong> +88-02-47117674, 223386738, <strong>Mobile:</strong> +88 01711-843583, +88 01300-027111
              </div>
              <div style={{ fontSize: "12px", color: "#111", marginTop: "1px" }}>
                <strong>Email:</strong> nawabpur.sharifbearing@gmail.com
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center", fontSize: "38px", fontWeight: 700, marginTop: "4px", textDecoration: "underline" }}>
            Quotation
          </div>
        </div>
      );
    };

    const renderBrandFooter = () => {
      if (!hasBranding) return null;

      const logoSrc = brandLogoMap[selectedBrand] || "";
      const distributorText = selectedBrand === "ntn" ? "NTN Authorized Industrial Distributor" : "SKF Authorized Industrial Distributor";

      return (
        <div style={footerWrapStyle}>
          <div style={{ display: "flex", alignItems: "stretch", gap: "10px" }}>
            <div style={{ width: "200px", border: "1px solid #1f80c7", borderRadius: "6px", overflow: "hidden" }}>
              <img src={logoSrc} alt={`${selectedBrand.toUpperCase()} logo`} style={{ width: "100%", height: "72px", objectFit: "contain", display: "block", background: "#fff" }} />
              <div style={{ height: "8px", background: "#e43f4d" }} />
            </div>
            <div
              style={{
                flex: 1,
                border: "1px solid #1f80c7",
                borderRadius: "6px",
                overflow: "hidden",
                textAlign: "center",
              }}
            >
              <div style={{ background: "#8ab8dd", color: "#113355", padding: "8px 6px", fontSize: "20px", fontWeight: 600 }}>
                Sharif Bearing and Machineries
              </div>
              <div style={{ background: "#0f6fb8", color: "#fff", padding: "8px 6px", fontSize: "20px", fontWeight: 700 }}>
                {distributorText}
              </div>
            </div>
          </div>
        </div>
      );
    };

    const pageSafeCSS = `
      @page { size: A4; margin: 0; }
      @media print {
        html, body { margin: 0 !important; padding: 0 !important; }
      }
      .avoid-break { page-break-inside: avoid; break-inside: avoid; }
      .page-break { page-break-before: always; break-before: page; }
      table { border-collapse: collapse; }
      tr, td { page-break-inside: avoid; break-inside: avoid; }
    `;
    const a4css = `
      .a4 { font-size: 14px; }
      .a4 .body, .a4 table { font-size: 14px; }
    `;
    const hafa4css = `
      .hafa4 { width:500px !important; }
      .hafa4 .body, .hafa4 table { font-size: 14px; }
    `;
    const poscss = `
      .pos .body { font-size: 10px; }
      .pos .body, .pos table { font-size: 10px; }
    `;

    // No nested <html>/<body> tags. Use plain div wrappers.
    return (
      <div className="print-source">
        <style>{pageSafeCSS}</style>
        {institution != null && institution.pro_print_type === "a4" ? (
          <div className="a4" style={{
            paddingTop: hasBranding ? "4mm" : "21mm",
            paddingBottom: "0mm",
            paddingLeft: "5mm",
            paddingRight: "5mm",
            ...pageStyle
          }}>
            <style>{a4css}</style>
            {renderBrandHeader()}

            <div style={contentWrapStyle}>
              <PrintAbleSection
                authInfo={this.state.authInfo}
                saleId={this.props.saleId}
                print={true}
                showDetailedView={this.props.showDetailedView}
                footerImage={this.props.footerImage}
                selectedInvoiceNo={this.props.selectedInvoiceNo}
                selectedInvoice={this.props.selectedInvoice}
              />
            </div>
            {renderBrandFooter()}
          </div>
        ) : institution != null && institution.pro_print_type === "1/2a4" ? (
          <div className="hafa4" style={{ padding: "5px", ...pageStyle }}>
            <style>{hafa4css}</style>
            {renderBrandHeader()}

            <div style={contentWrapStyle}>
              <PrintAbleSection
                authInfo={this.state.authInfo}
                saleId={this.props.saleId}
                print={true}
                showDetailedView={this.props.showDetailedView}
                footerImage={this.props.footerImage}
                selectedInvoiceNo={this.props.selectedInvoiceNo}
                selectedInvoice={this.props.selectedInvoice}
              />
            </div>
            {renderBrandFooter()}
          </div>
        ) : institution != null && institution.pro_print_type === "pos" ? (
          <div className="pos" style={{ padding: "5px", ...pageStyle }}>
            <style>{poscss}</style>
            {renderBrandHeader()}

            <PrintAbleSection
              authInfo={this.state.authInfo}
              saleId={this.props.saleId}
              print={true}
              showDetailedView={this.props.showDetailedView}
              footerImage={this.props.footerImage}
              selectedInvoiceNo={this.props.selectedInvoiceNo}
              selectedInvoice={this.props.selectedInvoice}
            />
            {renderBrandFooter()}
          </div>
        ) : null}
      </div>
    );
  }
}

let SalesInvoice = ({ authInfo, saleId, institution, selectedInvoiceNo, selectedInvoice }) => {
  const history = useHistory();
  const [showDetailedView, setShowDetailedView] = useState(false);
  const [footerImage, setFooterImage] = useState("skf");

  const componentRef = useRef(null);

  const waitForImages = async (root) => {
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
    const imgs = Array.from(root.querySelectorAll("img"));
    await Promise.all(
      imgs.map(
        (img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((res) => {
              const done = () => {
                img.removeEventListener("load", done);
                img.removeEventListener("error", done);
                res();
              };
              img.addEventListener("load", done);
              img.addEventListener("error", done);
            })
      )
    );
  };

  const handleDownloadPdf = async () => {
    const source = componentRef.current;
    if (!source) return;

    // Capture from the same DOM used for print preview to keep header/footer identical.
    const tempWrap = document.createElement("div");
    tempWrap.style.position = "fixed";
    tempWrap.style.left = "-10000px";
    tempWrap.style.top = "0";
    tempWrap.style.width = "794px";
    tempWrap.style.background = "#fff";
    tempWrap.style.zIndex = "-1";

    const clone = source.cloneNode(true);
    tempWrap.appendChild(clone);
    document.body.appendChild(tempWrap);

    const targets = clone.querySelectorAll(".print-source");
    targets.forEach((el) => {
      el.style.display = "block";
      el.style.visibility = "visible";
      el.style.position = "relative";
      el.style.left = "0";
      el.style.top = "0";
      el.style.zIndex = "0";
      el.style.opacity = "1";
    });

    await waitForImages(clone);

    const canvas = await html2canvas(clone, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      imageTimeout: 0,
      backgroundColor: "#ffffff",
    });
    document.body.removeChild(tempWrap);

    // compose PDF pages (A4)
    const pdf = new jsPDF("p", "mm", "a4");
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    const pxPerMm = canvas.width / pageW;
    const pageHpx = Math.round(pageH * pxPerMm);

    const pageCanvas = document.createElement("canvas");
    const ctx = pageCanvas.getContext("2d");
    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(canvas.height, pageHpx);

    let y = 0;
    while (y < canvas.height) {
      const slice = Math.min(pageHpx, canvas.height - y);

      if (ctx) {
        ctx.clearRect(0, 0, pageCanvas.width, pageCanvas.height);
        ctx.drawImage(canvas, 0, y, canvas.width, slice, 0, 0, pageCanvas.width, slice);
      }

      try {
        pdf.addImage(pageCanvas, "PNG", 0, 0, pageW, slice / pxPerMm);
      } catch {
        const jpeg = pageCanvas.toDataURL("image/jpeg", 0.98);
        pdf.addImage(jpeg, "JPEG", 0, 0, pageW, slice / pxPerMm);
      }

      y += slice;
      if (y < canvas.height) pdf.addPage();
    }

    pdf.save(`Quotation-invoice-${saleId}.pdf`);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={8} className={"invoice-section"}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Print Button */}
          <ReactToPrint
            trigger={() => (
              <Button size="small" variant="outlined" startIcon={<PrintIcon />}>
                Print
              </Button>
            )}
            content={() => componentRef.current}
            documentTitle={`Quotation-invoice-${saleId}`}
          />

          {/* Download PDF Button */}
          <Tooltip title="Download PDF">
            <Button size="small" variant="outlined" startIcon={<GetAppIcon />} onClick={handleDownloadPdf}>
              Download PDF
            </Button>
          </Tooltip>
        </div>

        {/* On-screen print tree (for ReactToPrint) */}
        <div ref={componentRef}>
          <ComponentToPrint
            authInfo={authInfo}
            saleId={saleId}
            institution={institution}
            showDetailedView={showDetailedView}
            footerImage={footerImage}
            selectedInvoiceNo={selectedInvoiceNo}
            selectedInvoice={selectedInvoice}
          />
        </div>

        <PrintAbleSection
          authInfo={authInfo}
          saleId={saleId}
          showDetailedView={showDetailedView}
          setShowDetailedView={setShowDetailedView}
          footerImage={footerImage}
          setFooterImage={setFooterImage}
          history={history}
          selectedInvoiceNo={selectedInvoiceNo}
          selectedInvoice={selectedInvoice}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToPops = (state) => ({
  authInfo: state.authInfoReducer,
});

export default connect(mapStateToPops, {})(SalesInvoice);
